import { disabledVariants } from "@opensea/ui-kit"
import { Star, StarFilled } from "@opensea/ui-kit/icons"

type Props = {
  isFilled?: boolean
  loading?: boolean
  size?: number
}

export function CurrencyWatchlistIcon({ isFilled, loading, size = 16 }: Props) {
  return isFilled ? (
    <StarFilled fill="warning" size={size} />
  ) : (
    <Star className={disabledVariants({ disabled: loading })} size={size} />
  )
}
